export const MAX_VALUE_PHONE = 16;
